import { useTheme } from "@mui/material/styles";
const getColorStyles = (colorProps, theme) => {
    const { color = "inherit", colorSet = "main", invertColors = false } = colorProps;
    const colorValue = colorSet;
    const contrastColorValue = colorSet === "main" ? "onMain" : "onContainer";
    return {
        backgroundColor: color === "inherit"
            ? "inherit"
            : theme.palette[color][invertColors ? contrastColorValue : colorValue],
        color: color === "inherit"
            ? "inherit"
            : theme.palette[color][invertColors ? colorValue : contrastColorValue],
    };
};
const getColorStylesFactory = (theme) => (colorProps) => getColorStyles(colorProps, theme);
/**
 * @deprecated Use ColorsProvider from `/lab`
 */
export const ColorsInjector = ({ props, children, }) => {
    const theme = useTheme();
    const getColorStyles = getColorStylesFactory(theme);
    return children({ ...props, getColorStyles: getColorStyles });
};
//# sourceMappingURL=colors.js.map